import applogger from '@applogger'

const asyncLoader = function({store}) {
  const __loader = () => {
    applogger.debug('page-footer asyncData start')
    let blobsToLoad = [
      'footer-link-list-1',
      'footer-link-list-2',
      'footer-link-list-3',
      'footer-terms',
      'footer-disclaimer',
      'footer-social-icons'
    ]

    return store.dispatch('blob/loadgroup', {blobIDs: blobsToLoad, cacheOptions: { scope: 'global', ttl: 3600 * 12 }})
      .then(_ => {
        applogger.debug('page-footer asyncData Complete')
      })
  }

  return store.dispatch('promisePool', {
    name: 'page-footer-0002',
    resolve: __loader
  })
}

const pageMixin = {
  data: function() {
    return {
      filestoreName: 'website',
      collapsed: true,
      socialAlignment: 'align-right',
      socialBranding: false
    }
  },
  computed: {
    copyright: function() {
      let siteType = this.$store.getters['getSiteSetting']('type', 'vincreative')
      return `copyright-${siteType}`
    }
  }
}

export default pageMixin
export {
  pageMixin,
  asyncLoader
}
